export default __webpack_public_path__ + "static/media/spiner.38efe1ee.gif";